import { FeatureFlag } from '../FeatureFlag';

export const allowFeedBackendTicker = new FeatureFlag({
    key: 'allow-feed-backend-ticker',
    createdOn: '2025-07-07',
    defaultValue: false,
});
